module.exports = __webpack_public_path__ + "img/DW365-144.ee7203b1.jpg";